module.exports = __webpack_public_path__ + "static/img/预算管控_标准版.82d767d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/预算管控_标准版.jpg
// module id = EX81
// module chunks = 1